<template>
  <ts-card>
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm">{{ $t('payrollCycleDate.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('payrollCycleDate.pcDateName') }}</label>
              <div>
                <ts-input
                  v-model="model.pc_date_name"
                  :class="{ 'is-invalid': errors.has('pc_date_name') }"
                  autofocus
                />
                <div class="invalid-feedback" v-if="errors.has('pc_date_name')">{{ errors.first('pc_date_name') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <div>
                <ts-checkbox v-model="model.monthly_based">{{ $t('payrollCycleDate.monthlyBased') }}</ts-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="ts-flex ts--mx-2">
          <div class="ts-w-1/2 ts-px-2">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('payrollCycleDate.dayFrom') }}</label>
              <div>
                <ts-select
                  v-model="model.day_from"
                  :options="dayRange(1, 32)"
                  :class="{ 'is-invalid': errors.has('day_from') }"
                  :disabled="model.monthly_based"
                />
                <div class="invalid-feedback" v-if="errors.has('day_from')">{{ errors.first('day_from') }}</div>
              </div>
            </div>
          </div>
          <div class="ts-w-1/2 ts-px-2">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('payrollCycleDate.dayTo') }}</label>
              <div>
                <ts-select
                  v-model="model.day_to"
                  :options="dayRange(1, 32)"
                  :class="{ 'is-invalid': errors.has('day_to') }"
                  :disabled="model.monthly_based"
                />
                <div class="invalid-feedback" v-if="errors.has('day_to')">{{ errors.first('day_to') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 ts-text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">{{ $t('button.cancel') }}</ts-button>
            <ts-button
              outline
              color="primary"
              class="ml-2"
              :waiting="savingAndNew"
              @click.prevent="saveAndNew"
              v-if="editData === undefined"
              >{{ $t('button.createAndNew') }}</ts-button
            >
            <ts-button color="primary" class="ml-2" :waiting="saving" @click.prevent="save">
              {{ editData ? $t('button.update') : $t('button.create') }}
            </ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { cloneDeep, range } from 'lodash'

export default {
  name: 'payroll-cycle-date-form',
  props: ['editData'],
  data() {
    const model = {
      pc_date_name: this.editData ? this.editData.pc_date_name : '',
      monthly_based: this.editData ? this.editData.monthly_based : false,
      day_from: this.editData ? this.editData.day_from : '',
      day_to: this.editData ? this.editData.day_to : ''
    }

    return {
      newModel: model,
      model: cloneDeep(model),
      errors: new Errors(),
      saving: false,
      savingAndNew: false,
      checkingSyntax: false,
      correctSyntaxMessage: '',
      gettingVariableName: false
    }
  },
  computed: {
    dayRange: vm => (start, end) => {
      return range(start, end)
    }
  },
  methods: {
    submit() {
      let responseResult

      this.errors = new Errors()

      if (this.editData) {
        responseResult = this.$store.dispatch('hr/payrollCycleDate/update', {
          id: this.editData.pc_date_id,
          ...this.model
        })
      } else {
        responseResult = this.$store.dispatch('hr/payrollCycleDate/create', this.model)
      }

      return responseResult
        .then(response => {
          return this.$store.dispatch('hr/payrollCycleDate/fetch').then(res => {
            this.saving = false
            this.$toasted.success(response.message)
            return Promise.resolve(res)
          })
        })
        .catch(error => {
          if (error.errors) this.errors = new Errors(error.errors)
          else this.$toasted.error(error.message)

          return Promise.reject(error)
        })
    },
    save() {
      this.saving = true

      this.submit()
        .then(() => {
          this.$emit('close')
        })
        .finally(() => {
          this.saving = false
        })
    },
    saveAndNew() {
      this.savingAndNew = true

      this.submit()
        .then(() => {
          this.model = cloneDeep(this.newModel)
        })
        .finally(() => {
          this.savingAndNew = false
        })
    }
  },
  watch: {
    'model.monthly_based': function(value) {
      if (value) {
        this.model.day_from = ''
        this.model.day_to = ''
      }
    }
  }
}
</script>
